import { Card, CardActions, CardContent, CardHeader, LinearProgress, Stack } from "@mui/material";
import type { FC } from "react";
import { useForm } from "react-hook-form";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import CancelButton from "../../components/cancelButton/CancelButton";
import FormNumberField from "../../components/formComponents/FormNumberField";
import type { PriceSettings } from "./priceSettingsApi";
import { usePriceSettings } from "./usePriceSettings";

const PricesForm: FC<{
  readonly value: PriceSettings;
  readonly onSubmit: (settings: PriceSettings) => Promise<PriceSettings>;
}> = ({ value, onSubmit }) => {
  const { control, handleSubmit, reset } = useForm<PriceSettings>({ defaultValues: value });

  return (
    <Card>
      <CardHeader title="Ceny" />
      <CardContent>
        <Stack spacing={2}>
          <FormNumberField control={control} name="dmcMarginMultiplier" label="Marża DMC (mnożnik)" />
          <FormNumberField control={control} name="eurExchangeRate" label="Kurs PLN/EUR" />
        </Stack>
      </CardContent>
      <CardActions>
        <Stack direction="row" spacing={2} sx={{ justifyContent: "flex-end", width: "100%" }}>
          <CancelButton onClick={() => reset()} />
          <AsyncLoadingButton
            onClick={handleSubmit(async (s) => {
              await onSubmit(s);
            })}
          >
            Zapisz
          </AsyncLoadingButton>
        </Stack>
      </CardActions>
    </Card>
  );
};

const PriceSettingsCard: FC = () => {
  const { isLoading, data, updateSettings } = usePriceSettings();
  if (isLoading || !data) {
    return (
      <Card>
        <CardHeader title="Ceny" />
        <CardContent>
          <LinearProgress data-testid="loading-indicator" />
        </CardContent>
      </Card>
    );
  }
  return <PricesForm value={data} onSubmit={updateSettings} />;
};

export default PriceSettingsCard;
